import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

interface VersionStamp {
  commitSha?: string;
}

export class CacheBustingTranslateLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<object> {
    return this.http.get<VersionStamp>('./assets/version.json').pipe(
      map(info => (typeof info?.commitSha === 'string' && info.commitSha ? info.commitSha : String(Date.now()))),
      catchError(() => of(String(Date.now()))),
      switchMap(bust =>
        this.http.get(`./assets/i18n/${lang}.json?v=${encodeURIComponent(bust)}`),
      ),
    );
  }
}
